import { TooltipWithIcon } from "@root/shared/components/TooltipWithIcon";
import { type FC } from "react";
import * as styles from "./styles.css";

export const TotalCountInfoTooltip: FC = () => (
  <TooltipWithIcon arrowPosition="leftBottom">
    <div className={styles.content}>
      最終アクセス日時から、応募可能性が低い求職者を除外して表示しています。
    </div>
  </TooltipWithIcon>
);
